module.exports = __webpack_public_path__ + "static/img/back.f8b2e26d.png";